export default __webpack_public_path__ + "static/media/logo.9f704282.png";